import { render, staticRenderFns } from "./LoadingGlobal.vue?vue&type=template&id=662c369c&scoped=true&"
import script from "./LoadingGlobal.vue?vue&type=script&lang=js&"
export * from "./LoadingGlobal.vue?vue&type=script&lang=js&"
import style0 from "./LoadingGlobal.vue?vue&type=style&index=0&id=662c369c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662c369c",
  null
  
)

export default component.exports